var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-layout',{attrs:{"breadcrumbs":_vm.breadcrumbs,"title":_vm.title}},[(!_vm.loadedAll)?_c('o-main-progress'):_c('Documentacion',{attrs:{"simplificada":false},on:{"error":_vm.error,"terminado":_vm.terminadoPaso,"cambiado":function($event){_vm.cambiadoAlert = $event}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c75376c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/reservas/_id/documentacion.vue
// module id = null
// module chunks = 